import { useCurrentUser } from "./useAuth";
import { hasPermission, type Permission } from "./permissions";

/** `true` when the signed-in operator holds `permission` (per `/api/auth/me`). */
export function usePermission(permission: Permission): boolean {
  return hasPermission(useCurrentUser(), permission);
}
